import { render, staticRenderFns } from "./ProfilePhotoUpload.vue?vue&type=template&id=0b2c0c3e"
import script from "./ProfilePhotoUpload.vue?vue&type=script&lang=js"
export * from "./ProfilePhotoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports